module.exports = __webpack_public_path__ + "img/am-sep-icon.953dfca8.gif";